




















import { Component, Vue, Prop } from "vue-property-decorator";
import VServiceTaskTableRowHeader from "./VServiceTaskTableRowHeader.vue";

@Component({
  components: {
    VServiceTaskTableRowHeader
  }
})
export default class VServiceTaskTable extends Vue {
  @Prop({ required: true }) rows!: number;
  @Prop({ default: 6 }) columns!: number;

  get onMobile() {
    return this.$store.getters.onMobile;
  }
  screenWidth_03: number = (window.innerWidth - 20) * 0.3;
  screenWidth_06: number = (window.innerWidth - 20) * 0.7;

  handleResize() {
    this.screenWidth_03 = (window.innerWidth - 20) * 0.3;
    this.screenWidth_06 = (window.innerWidth - 20) * 0.7;
  }

  get dynamicStyles() {
    const baseStyles = {
      "--min-width03": this.screenWidth_03 + "px",
      "--min-width06": this.screenWidth_06 + "px"
    };

    const mobileGrid = `100px repeat(${this.columns}, minmax(0, 300px))`;
    const desktopGrid = `100px repeat(${this.columns}, 1fr)`;

    return {
      ...baseStyles,
      gridTemplateColumns: this.onMobile ? mobileGrid : desktopGrid
    };
  }

  mounted() {
    window.addEventListener("resize", this.handleResize);
  }
}
